import { render, staticRenderFns } from "./popup_your_delivery.vue?vue&type=template&id=2e72636e&scoped=true&"
import script from "./popup_your_delivery.vue?vue&type=script&lang=js&"
export * from "./popup_your_delivery.vue?vue&type=script&lang=js&"
import style0 from "./popup_your_delivery.vue?vue&type=style&index=0&id=2e72636e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e72636e",
  null
  
)

export default component.exports